import { Component, ElementRef, OnInit, OnDestroy, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatLegacyChipInputEvent as MatChipInputEvent } from '@angular/material/legacy-chips';
import { map, Observable, startWith } from 'rxjs';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { RootScopeService } from 'src/app/services/root-scope.service';
import { InteractionHistoryService } from 'src/app/services/interaction-history.service';
import _ from 'lodash';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import * as _moment from 'moment';
import { default as _rollupMoment } from 'moment';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { InteractionHistoryListViewComponent } from '../interaction-history-list-view/interaction-history-list-view.component';
import * as Constants from '../../../models/Constants';
import { ApiService } from 'src/app/services/api.service';
//declare var $: any;

const moment = _rollupMoment || _moment;
// added code to format date in text box- e.g - May-30-2023
export const MY_FORMATS = {
  parse: {
    dateInput: 'll',
  },
  display: {
    dateInput: 'MMM-DD-YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'll',
    monthYearA11yLabel: 'MMM YYYY',
  },
};

@Component({
  selector: 'app-filter-data',
  templateUrl: './filter-data.component.html',
  styleUrls: ['./filter-data.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})

export class FilterDataComponent implements OnInit, OnDestroy {

  // range -- getting start & end Date from datepicker
  range = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });
  maxDate!: Date;
  minDate = this.range.value.start;
  @ViewChild(InteractionHistoryListViewComponent) listViewComponent;

  addEvent(event: MatDatepickerInputEvent<Date>) {
    this.minDate = this.range.value.start;
  }


  iconConfig: any;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  AgentValue = new FormControl('');
  topicValue = new FormControl('');
  filteredAgent: Observable<string[]>;
  filteredTopic: Observable<string[]>;
  selectedAgents: string[] = [];
  selectedTopics: string[] = [];
  allAgents: string[] = [];
  allTopics: string[] = [];

  isChecked: boolean = false;
  @ViewChildren("channelLists") channelLists: QueryList<ElementRef> | undefined;
  @ViewChildren("domainLists") domainLists: QueryList<ElementRef> | undefined;
  @ViewChild('AgentInput') AgentInput!: ElementRef<HTMLInputElement>;
  @ViewChild('topicInput') topicInput!: ElementRef<HTMLInputElement>;
  isMaxAgents: boolean = false;
  isMaxTopics: boolean = false;
  selectedChannels: string[] = [];
  selectedDomains: string[] = [];
  loaderType: string = Constants.LOADER_TYPE.CARD;

  constructor(public rootScope: RootScopeService, public intHistService: InteractionHistoryService, public dialog: MatDialog, public apiService: ApiService) {

    this.iconConfig = {
      iconName: 'xmark',
      iconType: 'light'
    }
    this.filteredAgent = this.AgentValue.valueChanges.pipe(

      map((agent: string | null) => ((agent) ? this.filterList(agent) : this.allAgents.slice())),
    );

    this.filteredTopic = this.topicValue.valueChanges.pipe(

      map((topic: string | null) => ((topic) ? this.filterTopicList(topic) : this.allTopics.slice())),
    );
    this.maxDate = new Date();
    this.agentList();
    this.topicList();
  }


  ngOnInit(): void {
    this.setFilterFormValue();
    if (this.selectedAgents?.length > 0) {
      this.selectedAgents.forEach(x => {
        if (x) this.filterList(x)
      })
    }
    if (this.selectedTopics?.length > 0) {
      this.selectedTopics.forEach(x => {
        if (x) this.filterTopicList(x)
      })
    }

    this.createCheckboxList();
    this.createDomainCheckboxList();
  }

  /** 
 * method to set filter data after retaining data.
 * @author :Amarjeet Kumar
 */
  setFilterFormValue() {
    if (this.intHistService.IHListViewDataCAMap[this.rootScope.activeCustTab.customerSessionId]?.filterFormData) {
      let data = _.cloneDeep(this.intHistService.IHListViewDataCAMap[this.rootScope.activeCustTab.customerSessionId].filterFormData);
      //  let data = this.intHistService.IHListViewDataCAMap[this.rootScope.activeCustTab.id].filterFormData;
      this.selectedAgents = data.clientList;
      this.selectedChannels = data.channelList;
      this.selectedTopics = data.topicList;
      this.selectedDomains = data.domainList;
      this.range = new FormGroup({
        start: new FormControl<Date | null>(data.range.startDate ? new Date(data.range.startDate) : null),
        end: new FormControl<Date | null>(data.range.endDate ? new Date(data.range.endDate) : null),
      });

    }
  }

  /** 
 * method to create unique agents list from IH service .
 * @author :Amarjeet Kumar
 */
  agentList() {
    let data = [];
    let agentList: any = [];
    if (this.intHistService.IHListViewDataCAMap[this.rootScope.activeCustTab.customerSessionId]?.filteredData) {
      data = this.intHistService.IHListViewDataCAMap[this.rootScope.activeCustTab.customerSessionId]?.filteredData;
    }
    else {
      data = this.intHistService.IHListViewDataCAMap[this.rootScope.activeCustTab.customerSessionId];
    }
    if (data)
      data.forEach((el: any) => {
        agentList.push(el.agent)
        if (el?.children && el?.children.length > 0) {
          el?.children.forEach((ele: any) =>
            agentList.push(ele.agent))
        }
      });
    this.allAgents = _.uniq(agentList);
    this.updateAgentList()
  }

  /** 
  * method to create unique topic list from IH service .
  * @author :Amarjeet Kumar
  */
  topicList() {
    let data: any = [];
    let topicList: any = [];
    if (this.intHistService.IHListViewDataCAMap[this.rootScope.activeCustTab.customerSessionId]?.filteredData) {
      data = this.intHistService.IHListViewDataCAMap[this.rootScope.activeCustTab.customerSessionId]?.filteredData;
    }
    else {
      data = this.intHistService.IHListViewDataCAMap[this.rootScope.activeCustTab.customerSessionId];
    }

    if (data && data.length > 0) {
      let topic;
      data.forEach((x: any) => {
        topic = this.topicFormat(x.topic)
        if (topic)
          topicList.push(topic)
        if (x?.children && x?.children.length > 0) {
          x?.children.forEach((ele: any) => {
            topic = this.topicFormat(ele.topic)
            if (topic)
              topicList.push(topic)
          }
          )
        }
        // if (x.topic.includes(">>")) {
        //   const text = x.topic.split(">>").splice(1);
        //   splitData.push(((text.toString()).replace(',', '>>')).trim());
        // }
      })
    }
    this.allTopics = _.uniq(topicList);
    this.updateTopicList();
  }

  /** 
   * method to format topic list e.g. "topic>>subTopic" .
   * @author :Amarjeet Kumar
   */
  topicFormat(topic) {
    if (topic?.includes(Constants.TOPIC_ARROW)) {
      let text = topic.split(Constants.TOPIC_ARROW).splice(1);
      text = ((text.toString()).replace(',', Constants.TOPIC_ARROW)).trim();
      return text;
    }
  }

  /** 
   * method to add agent using enter button into array of selected Agents .
   * @author :Amarjeet Kumar
   */
  add(event: MatChipInputEvent): void {

    if (this.allAgents?.includes(event?.value)) {
      this.selectedAgents.push(event?.value);
    }
    event?.chipInput!.clear();
    this.AgentValue.setValue(null);

  }

  /** 
  * method to add topic using enter button into array of selected topics .
  * @author :Amarjeet Kumar
  */
  addTopic(event: MatChipInputEvent): void {
    //  const value = (event.value || '').trim();

    if (this.allTopics.includes(event?.value)) {
      this.selectedTopics.push(event.value);
    }
    event?.chipInput!.clear();
    this.topicValue.setValue(null);

  }
  /** 
  * method to remove agent from array of selected Agents .
  * @author :Amarjeet Kumar
  */
  remove(agent: string): void {
    const index = this.selectedAgents.indexOf(agent);
    if (index >= 0) {
      this.selectedAgents.splice(index, 1);
      this.allAgents.push(agent);
      this.updateAgentList()
      this.isMaxAgents = false;
      this.AgentInput.nativeElement.value = '';
      this.AgentValue.setValue(null);
    }
  }

  /** 
  * method to remove topic from array of selected Topics .
  * @author :Amarjeet Kumar
  */
  removeTopic(topic: string): void {
    const index = this.selectedTopics.indexOf(topic);
    if (index >= 0) {
      this.selectedTopics.splice(index, 1);
      this.allTopics.push(topic);
      this.updateTopicList()
      this.isMaxTopics = false;
      this.topicInput.nativeElement.value = '';
      this.topicValue.setValue(null);
    }
  }

  /** 
  * this.filteredAgent -- updating Agents dropdown list .
  * @author :Amarjeet Kumar
  */
  updateAgentList() {
    this.filteredAgent = this.AgentValue.valueChanges.pipe(
      startWith(null),
      map((agent: string | null) => (agent ? this.filterList(agent) : this.allAgents.slice())),
    );
  }

  /** 
 * this.filteredTopic -- updating Topics dropdown list .
 * @author :Amarjeet Kumar
 */
  updateTopicList() {
    this.filteredTopic = this.topicValue.valueChanges.pipe(
      startWith(null),
      map((topic: string | null) => (topic ? this.filterTopicList(topic) : this.allTopics.slice())),
    );
  }
  /** 
  * this.selectedAgents -- Keeping array of selected Agents .
  * @author :Amarjeet Kumar
  */
  selected(event: MatAutocompleteSelectedEvent): void {
    if (this.selectedAgents.length < 3) {
      this.selectedAgents.push(event?.option.viewValue);
      // this.AgentInput.nativeElement.value = '';
      // this.AgentValue.setValue(null);
      this.isMaxAgents = false;
    }
    else {
      this.isMaxAgents = true;
    }
    this.AgentInput.nativeElement.value = '';
    this.AgentValue.setValue(null);
  }

  /** 
* this.selectedTopics -- Keeping array of selected topics .
* @author :Amarjeet Kumar
*/
  selectedTopic(event: MatAutocompleteSelectedEvent): void {
    if (this.selectedTopics.length < 3) {
      this.selectedTopics.push(event?.option.viewValue);
      // this.topicInput.nativeElement.value = '';
      // this.topicValue.setValue(null);
      this.isMaxTopics = false;
    }
    else {
      this.isMaxTopics = true;
    }
    this.topicInput.nativeElement.value = '';
    this.topicValue.setValue(null);
  }
  /** 
   * this.allAgents -- updating all agent list .
   * @author :Amarjeet Kumar
   */
  filterList(value: string): string[] {
    const filterValue = value.toLowerCase();
    if (this.allAgents.find(x => x.toLowerCase() == filterValue) && this.selectedAgents.length < 3)

      return this.allAgents = this.allAgents.filter(x => x.toLowerCase() != filterValue)
    else
      return this.allAgents.filter(agent => agent.toLowerCase().includes(filterValue));
  }

  /** 
 * this.allTopics -- updating all topic list .
 * @author :Amarjeet Kumar
 */
  filterTopicList(value: string): string[] {
    const filterValue = value.toLowerCase();
    if (this.allTopics.find(x => x.toLowerCase() == filterValue) && this.selectedTopics.length < 3)
      return this.allTopics = this.allTopics.filter(x => x.toLowerCase() != filterValue)
    else
      return this.allTopics.filter(topic => topic.toLowerCase().includes(filterValue));
  }

  /** 
    * this.selectedChannels -- Keeping array of selected channels .
    * @author :Amarjeet Kumar        
  */

  channelList(event: any): void {
    const payload = (event as CustomEvent<{
      uuid: string;
      checked: boolean;
      value: string;
    }>).detail;

    this.rootScope.awldsCustomerIHChannelLists = this.rootScope.awldsCustomerIHChannelLists.map((item) =>
      item.uuid == payload.uuid ? { ...item, checked: payload.checked } : item
    );

    this.selectedChannels = this.rootScope.awldsCustomerIHChannelLists
      .filter((item) => item.checked)
      .map((item) => item.labelText.toLowerCase());
  }


  /** 
   * this.selectedDomains -- Keeping array of selected domains .
   * @author :Amarjeet Kumar
   */
  
  domainList(event: any): void {
    const payload = (event as CustomEvent<{
      uuid: string;
      checked: boolean;
      value: string;
    }>).detail;

    this.rootScope.ihDomainLists = this.rootScope.ihDomainLists.map((item) =>
      item.uuid == payload.uuid ? { ...item, checked: payload.checked } : item
    );

    this.selectedDomains = this.rootScope.ihDomainLists
      .filter((item) => item.checked)
      .map((item) => item.labelText.toLowerCase());
  }


  /**
    * Method to reset filter form value.
    * @author :Amarjeet Kumar
    */
  clearAll() {

    this.range.reset();
    this.selectedChannels = [];
    this.selectedDomains = [];
    this.selectedAgents = [];
    this.selectedTopics = [];
    this.isMaxAgents = false;
    this.isMaxTopics = false;
    this.channelLists?.forEach((data: any) => data._checked = false);
    this.domainLists?.forEach((data: any) => data._checked = false);
    this.allAgents = [];
    this.allTopics = [];
    this.agentList();
    this.topicList();
    this.rootScope.activeCustTab.interactionFilterFail = false;

    // Reset checkbox values in rootScope
  if (this.rootScope.awldsCustomerIHChannelLists) {
    this.rootScope.awldsCustomerIHChannelLists = this.rootScope.awldsCustomerIHChannelLists.map(item => ({
      ...item,
      checked: false
    }));
  }

  // Reset domain checkbox values in rootScope
  if (this.rootScope.ihDomainLists) {
    this.rootScope.ihDomainLists = this.rootScope.ihDomainLists.map(item => ({
      ...item,
      checked: false
    }));
  }

  }

  /**
    * Method to apply filter on IH list data.
    * @author :Amarjeet Kumar
    */
 
  apply() {
  // this.clearAll();  
    if(!this.isDateRangeWithin60Days()){
    let endDate;
    let startDate;
    let isTreeTableData = false;
    let tempFilterData = this.intHistService.IHListViewDataCAMap[this.rootScope.activeCustTab.customerSessionId];
    this.rootScope.activeCustTab.interactionFilterFail = false;

    if (tempFilterData?.filteredData) {
      tempFilterData = tempFilterData?.filteredData;
    }
    else {
      isTreeTableData = true;
    }

    startDate = this.range?.value?.start;
    endDate = moment(this.range?.value?.end).add(1, 'days');

    //filter from date
    if (this.range && this.range.value && (this.range.value.start || this.range.value.end)) {
      if (this.range.value?.start && !this.range.value?.end)
        tempFilterData = tempFilterData?.filter((data: any) => new Date(data?.begin) >= new Date(startDate));
      if (this.range.value.end && !this.range.value.start)
        tempFilterData = tempFilterData?.filter((data: any) => new Date(data?.begin) <= new Date(endDate));
      if (this.range.value.start && this.range.value.end)
        tempFilterData = tempFilterData?.filter((data: any) => (new Date(data?.begin) >= new Date(startDate)) && (new Date(data?.begin) <= new Date(endDate)));
    }

    //filter from agents
    if (this.selectedAgents && this.selectedAgents.length > 0) {
      // parent agent list filter
      let tempParentFilterData = tempFilterData?.filter((x: any) => this.selectedAgents.includes(x.agent))
      // child agent list filter
      let tempChildFilterData = tempFilterData.filter(c => c.children?.some(z => this.selectedAgents.some(x => x == z.agent)))
      tempFilterData = _.unionBy([...tempParentFilterData, ...tempChildFilterData], '_id');
    }

    //filter from channels
    if (this.selectedChannels && this.selectedChannels.length > 0) {
      tempFilterData = tempFilterData?.filter((x: any) => this.selectedChannels.includes(x.channel.toLowerCase()))
    }

    // filter from topics
    if (this.selectedTopics && this.selectedTopics.length > 0) {
      // parent topics list filter
      let tempParentFilterData = tempFilterData?.filter(x => this.selectedTopics.find(v => x?.description?.includes(v)))
      // child topics list filter
      let tempChildFilterData = tempFilterData.filter(c => c.children?.some(z => this.selectedTopics.find(v => z?.description?.includes(v))))
      tempFilterData = _.unionBy([...tempParentFilterData, ...tempChildFilterData], '_id');
    }

    //filter from domins
    if (this.selectedDomains && this.selectedDomains.length > 0) {
      // parent domins list filter
      let tempParentFilterData = tempFilterData?.filter(x => this.selectedDomains.find(v => x?.description?.toLowerCase().includes(v.toLowerCase())))
      // child domins list filter
      let tempChildFilterData = tempFilterData.filter(c => c.children?.some(z => this.selectedDomains.find(v => z?.description?.toLowerCase().includes(v.toLowerCase()))))
      tempFilterData = _.unionBy([...tempParentFilterData, ...tempChildFilterData], '_id');
    }

    // Retaining filter form data
    let filterFormData: any = {
      range: { startDate: this.range.value.start, endDate: this.range.value.end },
      clientList: this.selectedAgents,
      channelList: this.selectedChannels,
      topicList: this.selectedTopics,
      domainList: this.selectedDomains
    }

    this.intHistService.IHListViewDataCAMap[this.rootScope.activeCustTab.customerSessionId].filterFormData = filterFormData;

    if (isTreeTableData) {
      this.intHistService.treeData = tempFilterData;
      this.intHistService.setAlightTreeTable(this.listViewComponent, {});
      this.intHistService.dataSource.next(tempFilterData);
      this.intHistService.isFilterApplied?.next(true);
      this.intHistService.IHListFilterViewDataCAMap[this.rootScope.activeCustTab.customerSessionId] = tempFilterData;
      this.intHistService.IHListFilterViewDataCAMap[this.rootScope.activeCustTab.customerSessionId].isTreeTable = true;
    }
    else {
      this.intHistService.interHistListViewTableData = new MatTableDataSource(tempFilterData);
      this.intHistService.treeData = tempFilterData;
      this.intHistService.dataSource.next(tempFilterData);
      this.intHistService.isFilterApplied?.next(true);
      this.intHistService.setAlightTreeTable(this.listViewComponent, {});
      this.intHistService.IHListFilterViewDataCAMap[this.rootScope.activeCustTab.customerSessionId] = new MatTableDataSource(tempFilterData);
      this.intHistService.IHListFilterViewDataCAMap[this.rootScope.activeCustTab.customerSessionId].isTreeTable = false;
    }


    this.intHistService.IHListViewDataCAMap[this.rootScope.activeCustTab.customerSessionId].isFilterApplied = true;
    // added condition to reset IH list Filter in case of blank form data 
    if (!this.range.value.end && !this.range.value.start && this.selectedChannels.length == 0 && this.selectedAgents.length == 0 && this.selectedTopics.length == 0 && this.selectedDomains.length == 0) {
      this.intHistService.IHListViewDataCAMap[this.rootScope.activeCustTab.customerSessionId].isFilterApplied = false;
    }

    //  this.rootScope.isFilterApplied = true;
    this.rootScope.openInteractionFilter=false;
    this.rootScope.accountModalPopup.set(this.rootScope.activeCustTab.customerSessionId,['openInteractionFilter' , false]);
    this.dialog.closeAll();
  }else{
    this.getIHDataForListViewForDateRange();
  }

  }
  
  /**Below method disable the Apply button
   * @returns boolean
   */
  disableApplyButton(): boolean {
    if ((!this.range?.value?.start &&
      !this.range?.value?.end && this.selectedChannels?.length == 0 &&
      this.selectedAgents?.length == 0 &&
      this.selectedTopics?.length == 0 &&
      this.selectedDomains?.length == 0 &&
      !this.intHistService.IHListViewDataCAMap?.[this.rootScope.activeCustTab?.customerSessionId]?.isFilterApplied) ||
      (this.range?.invalid && this.range?.dirty || this.checkDatesSelection() || this.validateDateRange())) {
      return true;
    }
    return false;
  }

  /**Below method returns the boolean value by taking start date and end date
   *  as a current date check the date range lie within 60 days period 
   * @returns boolean*/
   isDateRangeWithin60Days(): boolean {
    const start = this.range?.get('start')?.value;
  
    if (start) {
      const startDate = new Date(start);
      const endDate = new Date();
      endDate?.setHours(0, 0, 0, 0);
  
      if (!isNaN(startDate?.getTime()) && !isNaN(endDate?.getTime())) { // Validate start and end dates
        const millisecondsInDay = 1000 * 60 * 60 * 24;
        const differenceInDays = Math?.abs((endDate?.getTime() - startDate?.getTime()) / millisecondsInDay);
       
        return differenceInDays >= 60;
      }
    }
  
    return false;
  }
  
   /**Below method returns the boolean value by taking start date and end date
   *  checks the date range lie within 180 days period 
   * @returns boolean*/
   validateDateRange(): boolean {
    const start = this.range?.get('start')?.value;
    const end = this.range?.get('end')?.value;
    
    if (start && end) { // Check if both start and end dates are present
      const startDate = new Date(start);
      const endDate = new Date(end);
    
        if (!isNaN(startDate?.getTime()) && !isNaN(endDate?.getTime())) { // Validate start and end dates
        if (endDate >= startDate) { // Check if end date is greater than or equal to start date
          const millisecondsInDay = 1000 * 60 * 60 * 24;
          const differenceInDays = Math.abs((endDate?.getTime() - startDate?.getTime()) / millisecondsInDay);
       
          return differenceInDays >= this.rootScope.interactionHistoryConfig?.MAX_DAYS_FOR_LEGACYDATA;
        }
      }
    }
    return false; // If either start or end date is missing or invalid, or end date is less than start date, return false
  }
  
  
/**BeloW method check if start and end dates and return boolean based on the below condition */
  checkDatesSelection() {
    const startDate = this.range?.get('start')?.value;
    const endDate = this.range?.get('end')?.value;

    if (startDate == null && endDate == null) {
      return false;
    } else {
      if (startDate == null) {
        return true;
      } else if (endDate == null) {
        return true;
      } else {
        return false;
      }
    }

  }

/**Below method subscribe the observable and fetch the Interaction History data for the date range */
  getIHDataForListViewForDateRange() {
    let fromDate = this.rootScope.dateFormatter(this.range?.get('start')?.value, 'yyyy-MM-dd');
    let toDate = this.rootScope.dateFormatter(this.range?.get('end')?.value, 'yyyy-MM-dd');
    let dateRange: boolean = true;
    this.rootScope.activeCustTab.interactionFilterFail = false;
    this.rootScope.custAccInteractionFilterLoaderVariables.loader = true;
    this.rootScope.custAccInteractionFilterLoaderTimeoutId = setTimeout(() => {
      this.rootScope.custAccInteractionFilterLoaderVariables.loaderMsg = true;
    }, 1 * this.rootScope.showLoaderMsgThreshold * 1000);

    /* istanbul ignore next */
    this.apiService.getIHDataForListViewForDateRange(fromDate, toDate).subscribe({
      next: (data: any) => {

        clearTimeout(this.rootScope.custAccInteractionFilterLoaderTimeoutId);
        this.rootScope.custAccInteractionFilterLoaderVariables.loader = false;
        this.rootScope.custAccInteractionFilterLoaderVariables.loaderMsg = false;

        if (data?.['data'] && data?.['data']?.length > 0) {

          this.intHistService.modifyIHListViewData(data['data'], this.rootScope.activeCustTab?.IHSelectedRow, this, dateRange);
          this.modifyIHListFilterViewData();
        } else {
          let filterFormData: any = {
            range: { startDate: this.range?.value?.start, endDate: this.range?.value?.end },
            clientList: this.selectedAgents,
            channelList: this.selectedChannels,
            topicList: this.selectedTopics,
            domainList: this.selectedDomains
          }
          this.intHistService.IHListViewDataCAMap[this.rootScope.activeCustTab.customerSessionId].filterFormData = filterFormData;
          this.intHistService.treeData = [];
          this.intHistService.setAlightTreeTable(this.listViewComponent, {});
          this.intHistService.dataSource.next([]);
          this.intHistService?.isFilterApplied?.next(true);
          this.intHistService.IHListFilterViewDataCAMap[this.rootScope.activeCustTab.customerSessionId] = [];

          if( this.intHistService?.IHListFilterViewDataCAMap[this.rootScope.activeCustTab?.customerSessionId]){
          this.intHistService.IHListFilterViewDataCAMap[this.rootScope.activeCustTab.customerSessionId].isTreeTable = true;
          this.intHistService.IHListFilterViewDataCAMap[this.rootScope.activeCustTab.customerSessionId].moreRecordFound = false;
        }
        this.intHistService.IHListViewDataCAMap[this.rootScope.activeCustTab.customerSessionId].isFilterApplied = true;
          this.dialog.closeAll();
        }
        this.rootScope.openInteractionFilter=false;
        this.rootScope.accountModalPopup.set(this.rootScope.activeCustTab.customerSessionId, ['openInteractionFilter' , false]);

      },
      error: (error) => {

        clearTimeout(this.rootScope.custAccInteractionFilterLoaderTimeoutId);
        this.rootScope.custAccInteractionFilterLoaderVariables.loader = false;
        this.rootScope.custAccInteractionFilterLoaderVariables.loaderMsg = false;
        this.rootScope.activeCustTab.interactionFilterFail = true;

    let filterFormData: any = {
      range: { startDate: this.range?.value?.start, endDate: this.range?.value?.end },
      clientList: this.selectedAgents,
      channelList: this.selectedChannels,
      topicList: this.selectedTopics,
      domainList: this.selectedDomains
    }

    if(this.intHistService.IHListViewDataCAMap[this.rootScope.activeCustTab.customerSessionId])
        this.intHistService.IHListViewDataCAMap[this.rootScope.activeCustTab.customerSessionId].filterFormData = filterFormData;

      },
    })
  }

  /**BEloW method modfy the Interaction History data and check if the filtered data records are more than 500.*/
   
  modifyIHListFilterViewData() {

    let tempFilterData = this.intHistService.IHListFilterViewDateRangeDataCAMap?.[this.rootScope.activeCustTab?.customerSessionId];

    //filter from agents
    if (this.selectedAgents && this.selectedAgents?.length > 0) {
      // parent agent list filter
      let tempParentFilterData = tempFilterData?.filter((x: any) => this.selectedAgents?.includes(x?.agent))
      // child agent list filter
      let tempChildFilterData = tempFilterData?.filter(c => c.children?.some(z => this.selectedAgents?.some(x => x == z?.agent)))
      tempFilterData = _.unionBy([...tempParentFilterData, ...tempChildFilterData], '_id');
    }

    //filter from channels
    if (this.selectedChannels && this.selectedChannels.length > 0) {
      tempFilterData = tempFilterData?.filter((x: any) => this.selectedChannels?.includes(x?.channel?.toLowerCase()))
    }

    // filter from topics
    if (this.selectedTopics && this.selectedTopics?.length > 0) {
      // parent topics list filter
      let tempParentFilterData = tempFilterData?.filter(x => this.selectedTopics?.find(v => x?.description?.includes(v)))
      // child topics list filter
      let tempChildFilterData = tempFilterData?.filter(c => c?.children?.some(z => this.selectedTopics?.find(v => z?.description?.includes(v))))
      tempFilterData = _.unionBy([...tempParentFilterData, ...tempChildFilterData], '_id');
    }

    //filter from domins
    if (this.selectedDomains && this.selectedDomains?.length > 0) {
      // parent domins list filter
      let tempParentFilterData = tempFilterData?.filter(x => this.selectedDomains.find(v => x?.description?.toLowerCase().includes(v.toLowerCase())))
      // child domins list filter
      let tempChildFilterData = tempFilterData?.filter(c => c.children?.some(z => this.selectedDomains?.find(v => z?.description?.toLowerCase().includes(v.toLowerCase()))))
      tempFilterData = _.unionBy([...tempParentFilterData, ...tempChildFilterData], '_id');
    }

    // Retaining filter form data
    let filterFormData: any = {
      range: { startDate: this.range?.value?.start, endDate: this.range?.value?.end },
      clientList: this.selectedAgents,
      channelList: this.selectedChannels,
      topicList: this.selectedTopics,
      domainList: this.selectedDomains
    }
    this.intHistService.IHListViewDataCAMap[this.rootScope.activeCustTab.customerSessionId].filterFormData = filterFormData;

    if (tempFilterData.length < this.rootScope.interactionHistoryConfig?.MAX_IH_RECORDS_LEGACYDATA) {

      this.intHistService.treeData = tempFilterData;
      this.intHistService.setAlightTreeTable(this.listViewComponent, {});
      this.intHistService.showAlightTableComponent = false;
      this.intHistService.dataSource.next(tempFilterData);
      this.intHistService.isFilterApplied?.next(true);
      
      this.intHistService.IHListFilterViewDataCAMap[this.rootScope.activeCustTab.customerSessionId] = tempFilterData;
      if( this.intHistService?.IHListFilterViewDataCAMap[this.rootScope.activeCustTab?.customerSessionId] ){
        this.intHistService.IHListFilterViewDataCAMap[this.rootScope.activeCustTab.customerSessionId].isTreeTable = true;
        this.intHistService.IHListFilterViewDataCAMap[this.rootScope.activeCustTab.customerSessionId].moreRecordFound = false;
      }

      this.intHistService.IHListViewDataCAMap[this.rootScope.activeCustTab.customerSessionId].isFilterApplied = true;

      // added condition to reset IH list Filter in case of blank form data 
      if (!this.range?.value?.end && !this.range?.value?.start && this.selectedChannels?.length == 0 && this.selectedAgents?.length == 0 && this.selectedTopics?.length == 0 && this.selectedDomains?.length == 0) {
        this.intHistService.IHListViewDataCAMap[this.rootScope.activeCustTab.customerSessionId].isFilterApplied = false;
      }
    } else {
      let IHdata;
      if (this.intHistService.IHListViewDataCAMap?.[this.rootScope.activeCustTab?.customerSessionId]?.isFilterApplied) {
        IHdata = this.intHistService.IHListFilterViewDataCAMap[this.rootScope.activeCustTab.customerSessionId];
      }
      else {
        IHdata = this.intHistService.IHListViewDataCAMap[this.rootScope.activeCustTab.customerSessionId];
        this.intHistService.IHListFilterViewDataCAMap[this.rootScope.activeCustTab.customerSessionId] = IHdata;
        this.intHistService.IHListViewDataCAMap[this.rootScope.activeCustTab.customerSessionId].isFilterApplied = false;

      }

      this.intHistService.IHListFilterViewDataCAMap[this.rootScope.activeCustTab.customerSessionId].moreRecordFound = true;
      this.intHistService.treeData = IHdata;
      this.intHistService.setAlightTreeTable(this.listViewComponent, {});
      this.intHistService.dataSource.next(IHdata);

    }

    this.dialog.closeAll();
  }

  ngOnDestroy() {
    clearTimeout(this.rootScope.custAccInteractionFilterLoaderTimeoutId);
    this.rootScope.custAccInteractionFilterLoaderVariables.loader = false;
    this.rootScope.custAccInteractionFilterLoaderVariables.loaderMsg = false;
  }

  /* 
      @Author Jaya
      CCr6-1676 Function created for closing the Filter Modal. 
      */
  closeInteractionFilter(){
    this.rootScope.openInteractionFilter = false;
    this.rootScope.accountModalPopup.set(this.rootScope.activeCustTab.customerSessionId,['openInteractionFilter' , false]);
  }
  /**
     * Creates a checkbox list for agent IH channels if no channels are currently selected.
     * Maps the IHChannelList to a structured format with checkbox properties and assigns
     * it to rootScope.awldsCustomerIHChannelLists. Each item includes checked state, disabled state,
     * label text, initial value, and a unique identifier.
     * 
     */
  createCheckboxList() {
  if (this.selectedChannels.length > 0) {
    return;
  }

  // Use IHChannelList from rootScope if available
  
  const channelSource = this.rootScope.IHChannelList;
  
  // Check if channelSource exists and is an array
  if (channelSource && Array.isArray(channelSource)) {
    this.rootScope.awldsCustomerIHChannelLists = channelSource.map((item, index) => ({
      checked: false,
      disabled: false,
      labelText: item.fieldValue || item, // Access fieldValue property for objects, or use item directly for strings
      initialValue: item.fieldValue || item, // Access fieldValue property for objects, or use item directly for strings
      uuid: `interest-checkbox-${index}`
    }));
  } else {
    // If no channel source is available, create an empty array
    console.warn('No channel list available, creating empty checkbox list');
    this.rootScope.awldsCustomerIHChannelLists = [];
  }
}

/**
     * Creates a domain checkbox list for IH domain if no domains are currently selected.
     * Maps the IHDomainList to a structured format with checkbox properties and assigns
     * it to rootScope.ihDomainLists. Each item includes checked state, disabled state,
     * label text, initial value, and a unique identifier.
     * 
     */

createDomainCheckboxList() {
    if (this.selectedDomains.length > 0) {
      return;
    }

    // Use IHDomainLists from rootScope if available
    const domainSource = this.rootScope.filterDomainListData;

    // Check if domainSource exists and is an array
    if (domainSource && Array.isArray(domainSource)) {
      this.rootScope.ihDomainLists = domainSource.map((item, index) => ({
        checked: false,
        disabled: false,
        labelText: item.fieldValue || item, // Access fieldValue property for objects, or use item directly for strings
        initialValue: item.fieldValue || item, // Access fieldValue property for objects, or use item directly for strings
        uuid: `domain-checkbox-${index}`
      }));
    } else {
      // If no domain source is available, create an empty array
      console.warn('No domain list available, creating empty checkbox list');
      this.rootScope.ihDomainLists = [];
    }
  }
}
